/**
 * created by zhouzt on 2020-06-04
 *
 * description: 缓存常量
 *
 */
const store = {
	// 平台缓存
	PLATSTORE: 'PLATSTORE'
};

export default store;


// WEBPACK FOOTER //
// ./src/consts/store/index.js